/*
 * @Description: 一周用户情感倾向趋势-极坐标轴图
 * @Author: yy
 * @LastEditors: yy
 * @Date: 2019-02-20 10:59:40
 * @LastEditTime: 2019-03-29 17:29:16
 */
import baseChart from './customBaseChart';
import Color from 'color-js';

const createtr = (list, obj) => {
  return list.map((item, index) => `
    <tr>
      <td>${item.replace('群体', '')}</td>
      <td>${obj.kol[index].value}</td>
      <td>${obj.mua[index].value}</td>
    </tr>
  `).join('\n')
};

const createTable = (list, obj) => {
  return `
    <div style="border: 1px solid #f4f4f4; padding: 3px; color: #101010;">
      <table style="width: 150px; text-align: center; border: 1px solid #fff;font-size: 12px; background: #f3f3f3; border-collapse:collapse;">
        <tr>
          <th style="background: #e0e0e0;"></th>
          <th style="font-weight:400;background: #e0e0e0;">kol群体</th>
          <th style="font-weight:400;background: #e0e0e0;">普通群体</th>
        </tr>
        ${createtr(list, obj)}
      </table>
    </div>
  `
};

const itemStyle = (value, color) => ({
  value: value,
  itemStyle: {
    normal: {
      color: color
    }
  }
})

export default (opt = {}) => {

  const list = opt.list || [];

  const result = {
    mua: [],
    kol: [],
    axis: []
  };


  list.forEach(item => {
    result.mua.push(itemStyle(item.mua, Color(item.color).lightenByRatio(.2).toString()));
    result.kol.push(itemStyle(item.kol, item.color));
    result.axis.push(item.name);
  });


  return Object.assign(baseChart(opt), {
    angleAxis: {
      type: 'category',
      data: result.axis,
      z: 10,
      axisLine: {
        show:false
      }
    },
    radiusAxis: {},
    polar: {},
    legend: {
      show: true,
      right: 20,
      bottom: 10,
      selectedMode: false,
      orient: 'vertical',
      data: result.axis
    },
    tooltip: {
      show: true,
      position: {
        left: 20,
        bottom: 10
      },
      backgroundColor: 'rgba(0,0,0,0)',
      tirgger: 'axis',
      alwaysShowContent: true,
      formatter: () => {
        return createTable(result.axis, result)
      }
    },
    grid: {
      left: 300
    },
    series: [{
      type: 'bar',
      data: result.kol,
      coordinateSystem: 'polar',
      stack: 'a'
    }, {
      type: 'bar',
      data: result.mua,
      coordinateSystem: 'polar',
      stack: 'a'
    }]
  })
};


// WEBPACK FOOTER //
// src/chart/_emotionalTendencyPolar.js